import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import initBootstrapComponents from '../../utils/bootstrap';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useBasket } from '../../context/BasketContext';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { API_BASE_URL } from '../../constants/api';

// Import images
import alfaRomeoTonale from '../../assets/img/content/alfa-romeo-tonale.png';
import kiaNiro from '../../assets/img/content/kia-niro.png';
import LogoHeader from "../../components/Header/LogoHeader";

const AmbassadorLogin = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        remember: false
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        initBootstrapComponents();
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const formBody = new URLSearchParams();
            formBody.append('email', formData.email);
            formBody.append('password', formData.password);

            const response = await axios.post(`${API_BASE_URL}/login`, 
                formBody,
                {
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    withCredentials: true
                }
            );

            
            console.log(response);

            if (response.status == 200) {
                await login(response.data.token, response.data.id);
                
                // Add a small delay to ensure state is updated
                setTimeout(() => {
                    // Then navigate

                    localStorage.removeItem('bookingIds');
                    localStorage.removeItem('customerDetails');
                    localStorage.removeItem('basket');
                    localStorage.removeItem('bookingConfirmation');
                    
                    navigate('/', { replace: true });
                }, 100);
            } else {
                setError('Invalid credentials');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(err.response?.data?.message || 'An error occurred during login');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <LogoHeader />

            <main className="flex-grow-1 d-flex align-items-center py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="bg-motability-mid-black-5 rounded-4 p-5">
                                <h1 className="text-primary h2 mb-4">Login</h1>
                                
                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label text-dark">
                                            Username or email address
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control form-control-lg rounded-3 border-1"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label text-dark">
                                            Password
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type="password"
                                                className="form-control form-control-lg rounded-3 border-1"
                                                id="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                required
                                            />
                                            <button 
                                                type="button"
                                                className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none pe-3"
                                                onClick={() => {
                                                    const input = document.getElementById('password');
                                                    input.type = input.type === 'password' ? 'text' : 'password';
                                                }}
                                            >
                                                <i className="bi bi-eye text-primary"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="remember"
                                                name="remember"
                                                checked={formData.remember}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label" htmlFor="remember">
                                                Remember
                                            </label>
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary rounded-pill px-4 py-2"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        ) : null}
                                        Log in
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default AmbassadorLogin;
